'use client';

import { BANNER_CROP_MIN_WIDTH } from './constants';
import { FreeformCropStage } from './freeform-crop-stage';
import type { SelectionPixelsChangeHandler } from './types';

interface BannerCropStageProps {
  imageSrc: string;
  rotation: number;
  aspect: number;
  onSelectionPixelsChange: SelectionPixelsChangeHandler;
}

export function BannerCropStage({
  imageSrc,
  rotation,
  aspect,
  onSelectionPixelsChange,
}: BannerCropStageProps): React.JSX.Element {
  return (
    <FreeformCropStage
      imageSrc={imageSrc}
      rotation={rotation}
      mode="banner"
      aspect={aspect}
      minWidth={BANNER_CROP_MIN_WIDTH}
      rounded={false}
      onSelectionPixelsChange={onSelectionPixelsChange}
    />
  );
}
